import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment';

export class ShipmentSpotMarketBatchController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async cancelSpotMarkets(shipmentId: number): Promise<void> {
    await this.http.post<void>(`${shipmentId}/spot-market/batch/cancel`);
  }
}
